import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import classNames from 'classnames'

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';

import { getUsersInternals, getTotalUsers, changeStatusUser } from '@actions/users';

import { StatusString } from '@constants/general'
import { SET_VALUES_ADMIN } from '@constants/actionType'
import { getValueLanguageObj } from '@utils/general'

import store from '@store'

class Internals extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: {
        isVisible: false,
        title: '',
        children: null,
        textOk: '',
        textHide: '',
        actionOk: null,
        actionHide: () => {},
      },
      users: [],
      loading: false,
      totalRecords: 0,
      lazyParams: {
        first: 0,
        rows: 6,
        page: 0,
      },
      type: 'internal',
      findText: '',
      typeCountry: null,
      typeStatus: null,
      searchValues: {
        country: null,
        company: null,
        status: null,
        find: '',
      },
      objectSel: null,
      objectSelNode: null,
      showDlSeL: false,
      countryRequired: false,
      catalogCompanies: []
    };
    this.catalogStatus = [
      {label: this.props.t('Activos/Suspendidos') , id: StatusString.STATUS_SHOWABLE },
      {label: this.props.t('Activo') , id: StatusString.STATUS_ACTIVE },
      {label: this.props.t('Suspendido') , id: StatusString.STATUS_SUSPENDED }
    ]
  }

  componentDidMount() {
    // const { countriesCurrentCatalog } = this.props
    // this.setState({
    //   typeCountry: countriesCurrentCatalog[0]
    // }, () => this.searchData())
    // this.onChange({target: { name: 'typeStatus', value: this.catalogStatus[0] }})
    // this.loadTotal();
  }

  searchData = () => {
    const { findText, typeCountry, typeStatus, typeCompany } = this.state
    this.setState({
      searchValues: {
        country: typeCountry?.id || '',
        company: typeCompany?.id || '',
        status: typeStatus?.id || StatusString.STATUS_SHOWABLE,
        find: findText || '',
      },
    }, () => this.loadTotal())
  }

  loadTotal = async () => {
    const { getTotalUsers } = this.props
    const { type, searchValues } = this.state
    if (!searchValues.country) return this.setState({countryRequired: true})
    this.setState({ loading: true });

    const querys = {
      status: searchValues.status || StatusString.STATUS_SHOWABLE
    }
    if (searchValues.country) querys.country = searchValues.country
    if (searchValues.find) querys.find = searchValues.find

    const response = await getTotalUsers(querys);
    if (!response?.status) {
      this.setState({
        totalRecords: response.data.total
      });
      this.loadData()
    } else {
      this.setState({ loading: false});
    }
  }

  loadData = async () => {
    const { getUsersInternals } = this.props;
    const { lazyParams, searchValues } = this.state;
    this.setState({ loading: true });
    const querys = {
      page: lazyParams.page + 1,
      rows: lazyParams.rows,
      status: searchValues.status || StatusString.STATUS_SHOWABLE

    };
    if (lazyParams.sortOrder) querys.sortOrder = lazyParams.sortOrder ? 'asc' : 'desc';
    if (searchValues.country) querys.country = searchValues.country
    if (searchValues.find) querys.find = searchValues.find

    const response = await getUsersInternals(querys);
    if (!response?.status) {
      return this.setState({
        users: response.data,
        loading: false,
      });
    } 
    return this.setState({
      users: [],
      loading: false,
    });
    
  };

  onPage = (event) => {
    const { lazyParams } = this.state;
    const _lazyParams = { ...lazyParams, ...event };
    this.setState({ lazyParams: _lazyParams }, this.loadData);
  };

  onChangeSearch = (e) => {
    console.log(e);
    const { searchValues } = this.state;
    this.setState({
      searchValues: { ...searchValues, [e.target.name]: e.value },
    });
  };

  selectRegion = async (user) => {
    if(user){
      const {countriesCatalog, catalogBusiness, regiones, onHidden} = this.props
      const pais = getValueLanguageObj(JSON.parse(user.pais))
      
      const country = countriesCatalog?.find(b => b.label === pais)
      const company = catalogBusiness?.find(b => b.label === user.empresa && b.id_pais === country.id)
      
      const uRegiones = regiones?.find(r => r.key === `P${company.id_pais}` 
        && r.children?.find(c => c.key === `P${company.id_pais}-E${company.id}`))
      const uRegionSel = uRegiones?.children?.find(c => c.key === `P${company.id_pais}-E${company.id}`)
      let objectSel = {
        [`P${company.id_pais}`]: { checked: false, partialChecked: true},
        [`P${company.id_pais}-E${company.id}`]: { checked: true, partialChecked: false}
      }

      let paisData = {
        children: [],
        data: `${pais} País`,
        id: country.id,
        key: `P${country.id}`,
        label: pais,
        tipo: 'n'
      }

      let empresaData = {
        children: [],
        data: `${company.label} País`,
        id: company.id,
        key: `P${country.id}-E${company.id}`,
        label: company.label,
        tipo: 'e'
      }

      uRegionSel?.children?.map(r => {
        objectSel[r.key] = { checked: true, partialChecked: false}
        const regionData = {...r}
        empresaData.children.push(regionData)
      })

      paisData.children.push(empresaData)
      this.setState({
        objectSel: objectSel,
        objectSelNode: paisData,
        showDlSeL: true
      })
    }
  };

  selectUser = async (data) => {
    const { onHidden, tipoRol } = this.props
    await store.dispatch({
      type: SET_VALUES_ADMIN,
      payload: {user: data}
    })
    if(tipoRol.isRRHH){
      await this.selectRegion(data)
    } else 
    return onHidden()
  }
  
  columnResponsive = (rowData, detail) => (
    <>
        <span className="p-column-title">{detail.header}</span>
        {rowData[detail.field]}
    </>
  )

  statusTemplate = (node, detail) => {
    const { t } = this.props
    if (node.estatus === StatusString.STATUS_SUSPENDED) {
      return (
        <>
          <span className="p-column-title">{detail.header}</span>
          <span className="badge-red" aria-hidden="true"> {t('Suspendido').toUpperCase()} </span>
        </>
      );
    }
    if (node.estatus === StatusString.STATUS_ACTIVE) {
      return (
        <>
          <span className="p-column-title">{detail.header}</span>
          <span  aria-hidden="true"> {t('Activo')} </span>
        </>
      );
    }
  }

  selectTemplate = (rowData, detail) => {
    const { t } = this.props
    return (
    <>
      <span className="p-column-title">{detail.header}</span>
      <Button
        className=" p-button-text p-button-primary p-mr-2"
        label={t("Seleccionar")}
        onClick={() => this.selectUser(rowData)}
      />
    </>
  )};

   
  onChange = ({target}) => {
    this.setState({[target.name]: target.value}, () => {
      if (target.name === "typeCountry") {
        this.setState({countryRequired: false})
      }
    });
  };


  render() {
    const { t, countriesCurrentCatalog, onHidden, setSelectedNodeKeys, onChangeAllCompanies, onSelectEmpresas } = this.props
    const {
      users,
      lazyParams,
      totalRecords,
      loading,
      typeCountry,
      findText,
      countryRequired,
      showDlSeL,
      objectSel,
      objectSelNode
    } = this.state;
  
    const headerTable = (
        <div className="p-grid">
          <div className="p-col-12 p-md-6 p-lg-6 p-d-flex p-ai-center">
            <label className="p-mr-2 p-text-bold">{t('País')}:</label>
            <Dropdown
              name="typeCountry"
              value={typeCountry}
              options={countriesCurrentCatalog}
              onChange={this.onChange}
              optionLabel="label"
              filter
              // showClear
              filterBy="label"
              placeholder=""
              style={{ width: '100%' }}
              className={classNames({
                'p-invalid': countryRequired,
              })}
            />
          </div>
         <div className="p-col-12 p-md-6 p-lg-6 p-d-flex p-ai-center p-flex-column p-flex-sm-row p-jc-sm-center ">
            <div className="p-col p-d-flex p-ai-center is-full-width">
              <label className="p-mr-2 p-text-bold">{t('Texto')}:</label>
              <InputText
                name="findText"
                value={findText}
                onChange={this.onChange}
                className="p-mr-2 input-search-list"
              />
            </div>
            <div className="p-col is-full-width">
              <Button
                icon="pi pi-search"
                label={t('Buscar')}
                className="p-button-raised p-button-text p-button-plain btn-search-list"
                onClick={() => this.searchData()}
              />
            </div>
          </div>
        </div>
    );

    return (
      <>
        <Dialog
          header={t('Listado de usuarios internos')}
          visible
          breakpoints={{'960px': '90vw'}}
          style={{ width: '80vw' }}
          onHide={onHidden}
        >
        <div className="p-grid">
          <div className="p-col-12">
            <div className="card">
              <div className="p-grid">
                <div className="p-col-12">
                  <DataTable
                    value={users}
                    lazy
                    paginator={users.length ? true : false}
                    first={lazyParams.first}
                    rows={lazyParams.rows}
                    totalRecords={totalRecords}
                    onPage={this.onPage}
                    onSort={this.onSort}
                    loading={loading}
                    header={headerTable}
                    className="table-internals"
                  >
                    <Column field="empresa" header={t("Empresa")} body={this.columnResponsive} />
                    <Column field="nombre" header={t("Nombre")} body={this.columnResponsive} />
                    <Column field="puesto" header={t("Puesto")} body={this.columnResponsive} className="" />
                    <Column field="estatus" header={t("Estatus")} body={this.statusTemplate} className="" />
                    <Column header="Accion" body={this.selectTemplate} className=""/>
                  </DataTable>
                </div>
                { !users.length && (
                  <div className="p-col-12 not-information">
                    {t('No se encontraron resultados')}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        </Dialog>
        <Dialog
          header={t('Confirmación')}
          visible={showDlSeL}
          breakpoints={{'330px': '35vw'}}
          style={{ width: '30vw' }}
          onHide={onHidden}
        >
          <div className="p-col-12 p-field">
            <label className="p-text-bold">{t('¿El usuario será Administrador de su empresa?')}</label>
          </div>
          <div className="p-col-12 p-dialog-footer custom">
            <div className="p-d-flex p-jc-between">
              <Button
                label={t('No')}
                type="button"
                className="p-button-secondary p-button-text p-button-raised"
                onClick={() => {
                  setSelectedNodeKeys({})
                  onHidden()
                  }
                }
              />
              <Button
                label={t('Sí')}
                type="button"
                onClick={() => {
                  onChangeAllCompanies({e:{checked: false}})
                  setSelectedNodeKeys(objectSel)
                  onSelectEmpresas({node: objectSelNode})
                  onHidden()
                }}
                className="p-button-primary"
                //loading={btnLoading}
              />
            </div>
          </div>

        </Dialog>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  countriesCurrentCatalog: state.catalogs.countriesCurrentCatalog,
});

const mapDispatchToProps = {
  getUsersInternals,
  getTotalUsers,
  changeStatusUser
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
  )(Internals);
